import { BellRingingIcon as PhosphorBellRingingIcon } from "@phosphor-icons/react/dist/ssr/BellRinging";

import { createAppIcon } from "@/components/createAppIcon";

export const ActiveNotificationIcon = /* @__PURE__ */ createAppIcon(PhosphorBellRingingIcon);
